


















import { Vue, Component, Mixins, Watch, Prop } from 'vue-property-decorator';
import { infoAppointmentRecord } from '@/api/visitor-car-management';
@Component
export default class DetailBooking extends Vue {
  @Prop({ default: false })
  private value?: boolean;
  @Prop({ default: '', required: true })
  appointmentId?: string;
  detailModel = {};
  visitorsFieds = [
    {
      label: '车场名称：',
      prop: 'parkName'
    },
    {
      label: '访客车牌号：',
      prop: 'plateNo'
    },
    {
      label: '访客姓名：',
      prop: 'visitor'
    },
    {
      label: '预约来访时段：',
      prop: 'visitTime'
    },
    {
      label: '访客电话：',
      prop: 'visitorPhone'
    },
    {
      label: '访客到访状态：',
      prop: 'visitStatus'
    },
    {
      label: '来访事由：',
      prop: 'visitorTypeName'
    }
  ];
  ownerFieds = [
    {
      label: '业主姓名：',
      prop: 'ownerName'
    },
    {
      label: '业主电话：',
      prop: 'ownerPhone'
    },
    {
      label: '业主房号：',
      prop: 'ownerRoomNo'
    },
    {
      label: '操作时间：',
      prop: 'createTime'
    },
    {
      label: '备注：',
      prop: 'remark'
    }
  ];

  created() {
    this.getInfoAppointmentRecord(this.appointmentId);
  }
  async getInfoAppointmentRecord(appointmentId: any) {
    try {
      const { status, code, data } = await infoAppointmentRecord({
        appointmentId
      });
      if (status === '9999') {
        this.detailModel = data;
      }
    } catch (e) {
      console.log('infoAppointmentRecord,接口有误');
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    }
  }
  get visibleShow() {
    return this.value;
  }
  set visibleShow(val) {
    this.$emit('input', false);
  }
  handleCancel() {
    this.visibleShow = false;
  }
}
